import { BackLink } from "../../../app/components/BackLink.js";
import { useReturnNavigation, withReturnTo } from "../../../app/navigation/return-navigation.js";
import { Card, PageHeading } from "@peer-start/ui";
import { useTranslation } from "react-i18next";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { ActionLink } from "../../../app/components/ActionLink.js";
import { useAppContext } from "../../../app/use-app-context.js";
import { useAssessments } from "../../assessment/api/queries.js";
import { KnowledgeAssessmentPage } from "../../assessment/pages/KnowledgeAssessmentPage.js";
import { PassportQueryState } from "../components/PassportQueryState.js";
import { LegacyAreaAssessmentPage } from "./LegacyAreaAssessmentPage.js";

export function AreaAssessmentPage() {
  const { pageId } = useParams();
  return pageId === "route" ? <Navigate replace to="/me" /> : <TopicAssessmentPage />;
}

function TopicAssessmentPage() {
  const { t } = useTranslation();
  const { persona } = useAppContext();
  const { pageId = "" } = useParams();
  const [search] = useSearchParams();
  const query = useAssessments();
  const back = useReturnNavigation(`/me/passport/${pageId}`);
  const stampId = search.get("stamp");
  const banks =
    query.data?.filter((bank) => bank.pageId === pageId && (!stampId || bank.stampId === stampId)) ?? [];
  const selected =
    banks.find((bank) => bank.id === search.get("assessment")) ?? (banks.length === 1 ? banks[0] : undefined);
  if (query.isLoading || query.isError)
    return (
      <PassportQueryState
        children={null}
        error={query.isError}
        loading={query.isLoading}
        onRetry={() => void query.refetch()}
      />
    );
  if (selected)
    return <KnowledgeAssessmentPage key={`${persona.id}:${selected.id}`} id={selected.id} pageId={pageId} />;
  if (!banks.length) return <LegacyAreaAssessmentPage />;
  return (
    <>
      <BackLink controlId="assessment.choose.back" to={back.to}>
        {t(back.labelKey)}
      </BackLink>
      <PageHeading title={t("knowledgeAssessment.choose")} subtitle={t("knowledgeAssessment.intro")} />
      <Card>
        <div className="space-y-3">
          {banks.map((bank) => (
            <ActionLink
              key={bank.id}
              controlId={`assessment.choose.${bank.id}`}
              to={withReturnTo(`/me/assessment/${pageId}?assessment=${encodeURIComponent(bank.id)}`, back.to)}
              title={bank.title}
              description={t("knowledgeAssessment.questionCount", { count: bank.questionCount })}
            />
          ))}
        </div>
      </Card>
    </>
  );
}
